import Axios from "axios";
import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink,
    useParams,
    useRouteMatch,
    useHistory,
    Redirect,
} from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import Func from "../../functions";
import Loading from "../../layouts/Loading";
import Env from "../../env";

class EnterPayerInfoGCash extends Component {
    constructor(props) {
        super(props);
        this.state = {
            layout: "emu",
            step: "phone_number",
        };
    }

    componentDidMount = async () => {
        $(document).prop("title", "GCash Login");
        $("#favicon").attr("href", "/images/gcash/base_icon.png");
        this.props.i18n.changeLanguage(this.props.lngName);
    };

    componentWillUnmount = async () => {
        $(document).prop("title", "GCash");
    };

    setLoading = (v) => {
        this.setState({ isLoading: v });
    };

    showPayerInfo = () => {
        return this.props.payerName.substr(1);
    };

    showAmount = () => {
        return parseFloat(this.props.data.payAmount)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    };

    showStep = () => {
        let screenWidth = window.innerWidth;
        let pageFontSize = screenWidth / 7.5;
        if (pageFontSize > 60) {
            pageFontSize = 60;
        }
        if (pageFontSize == 60) {
            $(".gcashCashierHeader").css("height", "4.5rem");
            $(".gcashCashierHeader").css("margin-bottom", "-2.4rem");

            $("#gcashHeaderImg").css("margin", "0.54rem auto");
            $("#gcashHeaderImg").css("width", "4rem");

            $(".gcashCashierContent").css("margin", "0 auto 1em");
            $(".gcashCashierContent").css("background", "#fff");
        }

        if (this.state.step == "phone_number") {
            let desktopCss = {
                merchantInfo: {},
                merchantInfoRow: {},
                merchantInfoRowLabel: {},
                pageMainH2: "",
                pageMainLogin: {},
                pageFooterButton: {},
            };

            if (pageFontSize == 60) {
                desktopCss.merchantInfo = {
                    fontSize: "0.36rem",
                };
                desktopCss.merchantInfoRow = {
                    lineHeight: "0.72rem",
                };
                desktopCss.merchantInfoRowLabel = {
                    width: "2.7rem",
                };
                desktopCss.pageMainH2 = "desktop-h2";
                desktopCss.pageMainLogin = {
                    margin: "0.4rem 1.7rem 0",
                };
                desktopCss.pageFooterButton = {
                    marginTop: "1.2rem",
                };
            }

            let iPhoneStyle = {
                ipStyle: {},
                ipiStyle: {},
            };
            if (this.isIphone()) {
                iPhoneStyle.ipStyle = {
                    paddingTop: ".15rem",
                };
                iPhoneStyle.ipiStyle = {
                    marginBottom: "-.15rem",
                };
            }

            setTimeout(() => {
                if (this.props.payerName.length != 10) {
                    $("#inpPhNext").css("opacity", "0.5");
                    $("#inpPhNext").css("background-color", "#0f7efe");
                } else {
                    $("#inpPhNext").css("opacity", "1");
                    $("#inpPhNext").css("background-color", "#0057e4");
                }
                this.scrollToTop();
            }, 1000);

            return (
                <div className="main-container gcash-login-page">
                    <div
                        className="merchant-info"
                        style={desktopCss.merchantInfo}
                    >
                        <div className="row" style={desktopCss.merchantInfoRow}>
                            <label style={desktopCss.merchantInfoRowLabel}>
                                Merchant
                            </label>
                            <span className="merchant-name">
                                {Env.gcashTitle}
                            </span>
                        </div>
                        <div className="row" style={desktopCss.merchantInfoRow}>
                            <label style={desktopCss.merchantInfoRowLabel}>
                                Amount Due
                            </label>
                            <span className="amount">
                                PHP {this.showAmount()}
                            </span>
                        </div>
                    </div>
                    <div className="page-container">
                        <div className="page-main content-center">
                            <h2 className={desktopCss.pageMainH2}>
                                Login to pay with GCash
                            </h2>
                            {/* <p className="enter-mobile-number-label">
                                Enter your mobile number.
                            </p> */}
                            <div
                                className="login"
                                style={desktopCss.pageMainLogin}
                            >
                                <div
                                    accessbilityid="mobile-input"
                                    className="m-input hasPrefix notEmpty"
                                    autoFocus="autofocus"
                                >
                                    <div className="input-wrap">
                                        <div
                                            className="input-prefix"
                                            style={iPhoneStyle.ipStyle}
                                        >
                                            +63
                                        </div>
                                        <input
                                            style={iPhoneStyle.ipiStyle}
                                            maxLength="10"
                                            pattern="[0-9]*"
                                            value={this.props.payerName}
                                            inputMode="numeric"
                                            onChange={(e) => {
                                                this.props.changePayerName(e);
                                                if (
                                                    this.props.payerName
                                                        .length != 10
                                                ) {
                                                    $("#inpPhNext").css(
                                                        "opacity",
                                                        "0.5"
                                                    );
                                                    $("#inpPhNext").css(
                                                        "background-color",
                                                        "#0f7efe"
                                                    );
                                                } else {
                                                    $("#inpPhNext").css(
                                                        "opacity",
                                                        "1"
                                                    );
                                                    $("#inpPhNext").css(
                                                        "background-color",
                                                        "#0057e4"
                                                    );
                                                }
                                            }}
                                        />
                                        <div className="line"></div>
                                        <label className="placeholder">
                                            Mobile number
                                        </label>
                                    </div>
                                    <p className="error-text error-message"></p>
                                </div>
                            </div>
                        </div>
                        <footer>
                            <div
                                className="submit-button display-mobile"
                                style={desktopCss.pageFooterButton}
                            >
                                <button
                                    id="inpPhNext"
                                    type="button"
                                    className="ap-button ap-button-primary"
                                    accessbilityid="next-button"
                                    onClick={() => {
                                        if (this.props.payerName.length == 10) {
                                            this.props.enterPayerName();
                                        }
                                    }}
                                >
                                    NEXT
                                </button>
                            </div>
                        </footer>
                    </div>
                    {this.state.isLoading ? <Loading /> : ""}
                </div>
            );
        }
    };

    showFooter = () => {
        if (this.state.step == "phone_number") {
            let regWord = React.createElement(
                "p",
                {},
                "Don’t have a GCash account? ",
                React.createElement(
                    "span",
                    {
                        onClick: () => {
                            location.href = "https://lab.gcsh.app/r/";
                        },
                    },
                    "Register now"
                )
            );

            return regWord;
        } else {
            return "";
        }
    };

    isIphone = () => {
        let nua = navigator.userAgent;
        if (nua.includes("iPhone")) {
            return true;
        }
        if (nua.includes("Android")) {
            return true;
        }

        return false;
    };

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    render() {
        let screenWidth = window.innerWidth;
        let pageFontSize = screenWidth / 7.5;
        if (pageFontSize > 60) {
            pageFontSize = 60;
        }
        if (pageFontSize == 60) {
            $(".gcashCashierHeader").css("height", "4.5rem");
            $(".gcashCashierHeader").css("margin-bottom", "-2.4rem");

            $("#gcashHeaderImg").css("margin", "0.54rem auto");
            $("#gcashHeaderImg").css("width", "4rem");

            $(".gcashCashierContent").css("margin", "0 auto 1em");
            $(".gcashCashierContent").css("background", "#fff");
        }

        return (
            <div className="card gcashCashierMain">
                <div className="card-header gcashCashierHeader">
                    <img
                        id="gcashHeaderImg"
                        src="/images/gcash/gcash-white-new-logo.png"
                        alt=""
                    />
                </div>
                <div className="card-body gcashCashierContent">
                    {this.showStep()}
                </div>
                <div className="card-footer gcashCashierFooter">
                    {this.showFooter()}
                </div>
            </div>
        );

        // return (
        //     <div>
        //         <div className="form-group row" style={showPayerNameStyle}>
        //             <label className="col-sm-12 col-form-label text-sm">
        //                 {t("Cashier." + props.data.payerInfoType)}
        //             </label>
        //             <div
        //                 className="col-sm-12 input-group input-group-sm"
        //                 style={styles.rowMarginBottom}
        //             >
        //                 <input
        //                     id="payerName"
        //                     name="payerName"
        //                     className="form-control form-control-sm"
        //                     style={styles.inputReadOnlyStyle}
        //                     value={props.payerName}
        //                     onChange={(e) => props.changePayerName(e)}
        //                 />
        //                 <div className="input-group-append">
        //                     <button
        //                         type="button"
        //                         className="btn btn-sm btn-info btn-flat"
        //                         style={styles.inputEndRadius}
        //                         onClick={() => props.enterPayerName()}
        //                     >
        //                         {t("Cashier.Submit")}
        //                     </button>
        //                 </div>
        //                 <div className="input-group text-danger text-xs">
        //                     {t("Cashier." + props.data.payerInfoDesc)}
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // );
    }
}

export default hoistStatics(
    withTranslation()(EnterPayerInfoGCash),
    EnterPayerInfoGCash
);
